module.exports = __webpack_public_path__ + "media/images/icon_cancel-74f68c275d668e6a46fc0bea1dfe8b15.png";